import { render, staticRenderFns } from "./MachineCertificate.vue?vue&type=template&id=24dc4b96&"
import script from "./MachineCertificate.vue?vue&type=script&lang=ts&"
export * from "./MachineCertificate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports